<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesRitaCameraResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      custom-row-actions-text-first-column="操作"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <em-button
                                        type="qualified"
                                        class="btn btn-outline-primary btn-sm"
                                        :custom-icon="'fa ' + (row.alive ? 'fa-times' : 'fa-check')"
                                        customLabel="切换启用状态"
                                        :confirm-text="'是否' + (row.alive ? '关闭' : '开启') + '摄像头？'"
                                        :busy="changeAliveLoading"
                                        @click="changeAlive(row)"
                                    ></em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-08-12 09:47:05

import emCommonListMixin from "@/mixin/em/common/list";

export default {
    name: "sithMesRitaCameraListView",
    mixins: [emCommonListMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            changeAliveLoading: false
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        changeAlive(row) {
            this.changeAliveLoading = true;
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_RITA_URL + "/sithMesRitaCamera/selective",
                entity: {
                    id: row.id,
                    alive: !row.alive
                }
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => {
                this.changeAliveLoading = false;
            })
        }
    }
};
</script>